import appState from "src/model/state";

interface ShopDataRequired {
  shopId: number;
  shopMarketId: number;
  shopLang: string;
  shopLangId: number;
  expeditionDivision: boolean;
  apiHost: string;
  isMarketTaxes: boolean;
}

export const useShop = (): ShopDataRequired => {
  const { store, market } = appState.get();
  const shopDataRequired = {
    shopId: store.storeId,
    shopMarketId: market.marketId ?? store.storeId,
    shopLang: market.lang,
    shopLangId: market.langId,
    apiHost: market.apiHost,
    isMarketTaxes: market.isMarketTaxes,
    expeditionDivision: market.expeditionDivision,
  };
  return shopDataRequired;
};
